import { render, staticRenderFns } from "./cancelSale.vue?vue&type=template&id=6d984667&scoped=true"
import script from "./cancelSale.vue?vue&type=script&lang=js"
export * from "./cancelSale.vue?vue&type=script&lang=js"
import style0 from "./cancelSale.vue?vue&type=style&index=0&id=6d984667&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d984667",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d984667')) {
      api.createRecord('6d984667', component.options)
    } else {
      api.reload('6d984667', component.options)
    }
    module.hot.accept("./cancelSale.vue?vue&type=template&id=6d984667&scoped=true", function () {
      api.rerender('6d984667', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/cancelSale.vue"
export default component.exports